module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    ref: "wrap",
    class: _vm.styleClass,
    style: (_vm.styles)
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd7063ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop-box/pop-box.vue
// module id = 412
// module chunks = 0